import { useEffect, useState } from "react";
import { Briefcase, Check, Plus } from "lucide-react";
import api from "../lib/api";

export default function DigestSalesManagers({ onChanged }) {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/digest/sales-managers").then((r) => setRows(r.data.managers)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);

  const add = async (list) => {
    setBusy(true);
    for (const m of list) {
      try { await api.post("/digest/subscribers", { email: m.email, name: m.name || null }); } catch { /* ya suscrito */ }
    }
    setBusy(false); load(); onChanged?.();
  };
  if (!rows) return null;
  const pending = rows.filter((m) => !m.subscribed);
  return (
    <div className="mt-4 rounded-lg border border-blue-100 bg-blue-50/40 p-3" data-testid="digest-sales-managers">
      <div className="flex items-center justify-between gap-2 flex-wrap mb-2">
        <div className="text-[12px] font-extrabold flex items-center gap-1.5"><Briefcase size={13} className="text-blue-600"/> Gerentes de Ventas con acceso al dashboard ({rows.length})</div>
        {pending.length > 0 && (
          <button onClick={() => add(pending)} disabled={busy} data-testid="digest-add-all-managers"
                  className="btn primary text-[12px] flex items-center gap-1"><Plus size={12}/> {busy ? "Agregando..." : `Agregar los ${pending.length} pendientes`}</button>
        )}
      </div>
      {!rows.length && <div className="text-[12px] text-gray-500 font-semibold">No hay usuarios con rol Gerente de Ventas.</div>}
      {rows.map((m) => (
        <div key={m.email} className="flex items-center justify-between py-1.5 border-t border-blue-100 text-[13px]" data-testid={`digest-manager-${m.email}`}>
          <span><span className="font-bold">{m.name || "—"}</span> <span className="text-gray-500">{m.email}</span></span>
          {m.subscribed
            ? <span className="text-[11px] font-extrabold text-emerald-700 flex items-center gap-1"><Check size={12}/> Ya lo recibe</span>
            : <button onClick={() => add([m])} disabled={busy} className="text-[11px] font-extrabold text-blue-700 hover:underline" data-testid={`digest-add-manager-${m.email}`}>Agregar</button>}
        </div>
      ))}
    </div>
  );
}
